<template>
  <div class="login-page">
    <section class="login-card card" aria-labelledby="login-title">
      <div class="brand">
        <div class="brand-mark" aria-hidden="true">FM</div>
        <div class="brand-text">
          <span class="brand-name">FIDmarket</span>
          <span class="brand-kicker">Espace commerçant</span>
        </div>
      </div>

      <div class="login-header">
        <p class="eyebrow">Accès sécurisé</p>
        <h1 id="login-title">Connexion commerçant</h1>
        <p class="subtitle">Pilotez votre fidélité client depuis votre tableau de bord.</p>
      </div>

      <div class="form-stack">
        <div class="form-group">
          <label class="label" for="telephone">Téléphone</label>
          <input
            id="telephone"
            v-model="telephone"
            class="input login-input"
            type="tel"
            inputmode="tel"
            autocomplete="tel"
            placeholder="06 00 00 00 00"
            @keyup.enter="login"
          />
        </div>

        <div class="form-group">
          <label class="label" for="pin">PIN</label>
          <input
            id="pin"
            v-model="pin"
            class="input login-input pin-input"
            type="password"
            inputmode="numeric"
            autocomplete="current-password"
            maxlength="4"
            placeholder="4 chiffres"
            @keyup.enter="login"
          />
        </div>
      </div>

      <p v-if="erreur" class="error login-error" role="alert">{{ erreur }}</p>

      <button class="btn btn-primary login-submit" @click="login" :disabled="loading">
        <span v-if="loading" class="loading-dot" aria-hidden="true"></span>
        {{ loading ? 'Connexion...' : 'Se connecter' }}
      </button>
    </section>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'LoginView',
  data() {
    return {
      telephone: '',
      pin: '',
      erreur: '',
      loading: false
    }
  },
  methods: {
    async login() {
      this.erreur = ''
      if (!this.telephone || !this.pin) {
        this.erreur = 'Veuillez remplir tous les champs'
        return
      }

      this.loading = true
      try {
        const res = await api.post('/auth/login', {
          telephone: this.telephone,
          pin: this.pin
        })
        localStorage.setItem('token', res.data.token)
        localStorage.setItem('commercant', JSON.stringify(res.data.commercant))
        this.$router.push('/dashboard')
      } catch (err) {
        this.erreur = err.response?.data?.error || 'Identifiants incorrects'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  min-height: 100svh;
  display: grid;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(circle at top left, rgba(34, 197, 94, 0.13), transparent 32%),
    linear-gradient(160deg, #F8FAFC 0%, #EFF6FF 58%, #F8FAFC 100%);
}

.login-card {
  width: 100%;
  max-width: 430px;
  margin: 0;
  padding: 32px;
  border-radius: 18px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  box-shadow: 0 24px 70px rgba(13, 27, 61, 0.12);
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 30px;
}

.brand-mark {
  display: grid;
  width: 46px;
  height: 46px;
  place-items: center;
  border-radius: 14px;
  background: linear-gradient(145deg, var(--fm-navy) 0%, #123A2A 100%);
  color: #FFFFFF;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0;
  box-shadow: 0 12px 24px rgba(13, 27, 61, 0.18);
}

.brand-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.brand-name {
  color: var(--fm-navy);
  font-size: 18px;
  font-weight: 800;
  line-height: 1.1;
}

.brand-kicker {
  color: var(--fm-muted);
  font-size: 12px;
  font-weight: 600;
  margin-top: 3px;
}

.login-header {
  margin-bottom: 26px;
}

.eyebrow {
  color: #15803D;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  margin-bottom: 10px;
  text-transform: uppercase;
}

h1 {
  color: var(--fm-navy);
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 10px;
}

.subtitle {
  max-width: 340px;
  color: var(--fm-muted);
  font-size: 14px;
  line-height: 1.55;
}

.form-stack {
  display: grid;
  gap: 16px;
}

.form-group {
  text-align: left;
}

.login-input {
  min-height: 54px;
  padding: 15px 16px;
  background: #FBFDFF;
  border-color: #D7E0EA;
}

.login-input:focus {
  background: #FFFFFF;
  border-color: #22C55E;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.14);
}

.pin-input {
  letter-spacing: 0.08em;
}

.login-error {
  display: flex;
  align-items: center;
  min-height: 44px;
  margin: 16px 0 0;
  padding: 11px 13px;
  border: 1px solid #FECACA;
  border-radius: 12px;
  background: #FEF2F2;
  color: #B91C1C;
  font-size: 13px;
  font-weight: 600;
}

.login-submit {
  min-height: 54px;
  margin-top: 20px;
  background: linear-gradient(180deg, #2DD66D 0%, #16A34A 100%);
  box-shadow: 0 14px 30px rgba(22, 163, 74, 0.24);
}

.login-submit:hover:not(:disabled) {
  background: linear-gradient(180deg, #22C55E 0%, #15803D 100%);
}

.loading-dot {
  width: 10px;
  height: 10px;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #FFFFFF;
  border-radius: 999px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 600px) {
  .login-page {
    align-items: start;
    padding: 18px;
  }

  .login-card {
    align-self: center;
    padding: 24px 20px;
  }

  .brand {
    margin-bottom: 24px;
  }

  h1 {
    font-size: 25px;
  }

  .subtitle {
    font-size: 13px;
  }
}

@media (max-width: 380px) {
  .login-page {
    padding: 12px;
  }

  .login-card {
    padding: 20px 16px;
  }

  .brand-mark {
    width: 42px;
    height: 42px;
  }

  .login-header {
    margin-bottom: 20px;
  }

  .form-stack {
    gap: 12px;
  }
}
</style>
